export const RadioStyle = {
  // Styles for the base style
  baseStyle: {
    control: {
      _focus: {
        ring: 2,
        ringColor: "purple.500",
      },
    },
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {
    colorScheme: "purple",
  },
};
